import { secondsSince } from './clock'
import type { Service, Ticket } from './types'

/**
 * A piece of work run past its service's time limit: the Counter's timer turns
 * amber and Floor marks the desk. The same clock the server emails the managers by
 * (engine.ServiceTimeSweep): the current piece of work's start, while it is being
 * served. Computed here, live, rather than read off the server's mark, so the
 * colour changes on the second it should and not on the next sweep.
 */

type Limited = Pick<Service, 'id' | 'serviceTimeLimitMin'>

/** The service's limit in seconds, or 0 for none. */
export function serviceLimitSec(services: readonly Limited[], serviceId: string | undefined): number {
  const minutes = services.find((s) => s.id === serviceId)?.serviceTimeLimitMin ?? 0
  return minutes > 0 ? minutes * 60 : 0
}

export function overServiceLimit(
  ticket: Pick<Ticket, 'state' | 'transactions' | 'currentTransaction'> | undefined,
  services: readonly Limited[],
  now: number,
): boolean {
  if (!ticket || ticket.state !== 'serving') return false
  const tx = ticket.transactions[ticket.currentTransaction]
  const limit = serviceLimitSec(services, tx?.serviceId)
  return limit > 0 && !!tx?.startedAt && secondsSince(tx.startedAt, now) >= limit
}
